import { actionTypes as at, actionCreators } from '../actions';
import { ActionType } from 'typesafe-actions';
import Types from 'Types';

export type Action = ActionType<typeof actionCreators>;

export const initialState = {
  data: null,
  loading: false,
};

export const reducer = (state = initialState, { type, payload }: Action & Types.StoreAction) => {
  switch (type) {
      case at.REGISTRATION:
        return {
          data: null,
          loading: true,
        }
      case at.REGISTRATION_ERROR:
        return {
          ...state,
          loading: false,
          error: payload,
        }
      case at.REGISTRATION_SUCCESS:
        return {
          ...state,
          loading: false,
          data: payload,
        }
      default:
        return state;
  }
};

export const isLoading = ({ submitForm: { registration } }: Types.StoreState) => registration.loading;

export const getData = ({ submitForm: { registration } }: Types.StoreState) => registration.data;

